import { Title } from '../../../../../components/Title';
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const EmailTitle = () => <Title title='Sign In'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>;